import React from 'react';
import {Card, Modal} from 'antd';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import BreadcrumbToolbar from '../components/layouts/BreadcrumbToolbar'
import AccountTable from '../components/AccountTable';
import AccountTableMobile from '../components/AccountTableMobile';
import {fetchAccounts, updateAccount, updateAccountPermission, fetchPermissions, deleteAccount} from '../actions/account'
const confirm = Modal.confirm;
class Accounts extends React.Component {
  componentWillMount() {
    this.props.dispatch(fetchAccounts())
  }

  handleUpdate = (account) => {
    this.props.dispatch(updateAccount(account))
  }

  handleUpdatePermission = (account, permission) => {
    this.props.dispatch(updateAccountPermission(account, permission))
  }

  handleDelete = (account) => {
    this.props.dispatch(deleteAccount(account))
  }

  handleSelectionAccount = (accountID) => {
    this.props.dispatch(fetchPermissions(accountID))
  }

  render() {
    const {
      fetching,
      currentUser,
      currentSystem,
      accounts,
      permissions,
      groups,
      treeGroups,
      stations,
      fetchingGroups,
      fetchingStations,
      fetchingPermissions,
      isMobile,
      location
    } = this.props
    const role = currentUser
      ? currentUser.role
      : 256
    const breadcrumbs = [
      {
        Name: "Quản lý hệ thống",
        Link: `/systems`
      }, {
        Name: currentSystem.Name,
        Link: ""
      }
    ]
    const showBreadCurmbs = location.pathname.indexOf(currentSystem.ID) > -1
      ? true
      : false
    return (<div>
      {
        showBreadCurmbs
          ? <div className="toolbar">
              <BreadcrumbToolbar items={breadcrumbs}/>
            </div>
          : null
      }
      <Card title="Quản lí người dùng" bordered={false} className="card">{
          isMobile
            ? <AccountTableMobile role={role} accounts={accounts} groups={groups} treeGroups={treeGroups} stations={stations} permissions={permissions} fetching={fetching} fetchingGroups={fetchingGroups} fetchingStations={fetchingStations} fetchingPermissions={fetchingPermissions} onSelectionAccount={this.handleSelectionAccount} onUpdatePermission={this.handleUpdatePermission} onDelete={this.handleDelete}/>
            : <AccountTable role={role} accounts={accounts} groups={groups} treeGroups={treeGroups} stations={stations} permissions={permissions} fetching={fetching} fetchingGroups={fetchingGroups} fetchingStations={fetchingStations} fetchingPermissions={fetchingPermissions} onSelectionAccount={this.handleSelectionAccount} onUpdatePermission={this.handleUpdatePermission} onDelete={this.handleDelete}/>
        }
      </Card>
    </div>);
  }
}

Accounts.propTypes = {
  dispatch: PropTypes.func,
  currentSystem: PropTypes.object,
  currentUser: PropTypes.object,
  accounts: PropTypes.array,
  permissions: PropTypes.array,
  groups: PropTypes.array,
  stations: PropTypes.array,
  fetching: PropTypes.bool,
  fetchingGroups: PropTypes.bool,
  fetchingPermissions: PropTypes.bool,
  fetchingStations: PropTypes.bool,
  error: PropTypes.string
}

const mapStateToProps = function(state) {
  return {
    currentSystem: state.system.currentSystem,
    currentUser: state.user.currentUser,
    accounts: state.account.accounts,
    permissions: state.account.permissions,
    groups: state.group.groups,
    treeGroups: state.group.treeGroups,
    stations: state.station.stations,
    fetching: state.account.fetching,
    fetchingGroups: state.group.fetching,
    fetchingStations: state.station.fetching,
    fetchingPermissions: state.account.fetchingPermissions,
    error: state.account.error
  }
}

export default connect(mapStateToProps)(Accounts)



// WEBPACK FOOTER //
// ./src/pages/Accounts.js